import React from 'react';
import { Modal, Row, Col, Space, Typography } from 'antd';

const { Text } = Typography;

export const shortcutsList = [
  {
    category: 'GLOBAL',
    shortcuts: [
      { keys: ['Ctrl', 'K'], description: 'Open command palette' },
      { keys: ['?'], description: 'Show keyboard shortcuts' },
    ]
  },
  {
    category: 'NAVIGATION',
    shortcuts: [
      { keys: ['Ctrl', '1-9'], description: 'Jump to menu item' },
    ]
  },
  {
    category: 'ANY PAGE',
    shortcuts: [
      { keys: ['Ctrl', 'N'], description: 'Add new record' },
      { keys: ['Ctrl', 'S'], description: 'Save current form' },
      { keys: ['Ctrl', 'F'], description: 'Focus search' },
      { keys: ['Ctrl', 'R'], description: 'Refresh data' },
      { keys: ['Escape'], description: 'Close modal/cancel' },
    ]
  },
  {
    category: 'TRANSACTIONS',
    shortcuts: [
      { keys: ['Ctrl', 'Enter'], description: 'Add line item' },
      { keys: ['Ctrl', 'P'], description: 'Print document' },
    ]
  },
  {
    category: 'TABLE',
    shortcuts: [
      { keys: ['↑', '↓'], description: 'Navigate rows' },
      { keys: ['Enter'], description: 'Edit selected row' },
      { keys: ['Delete'], description: 'Delete selected row' },
    ]
  },
  {
    category: 'REPORTS',
    shortcuts: [
      { keys: ['Ctrl', 'L'], description: 'Load report' },
      { keys: ['Ctrl', 'E'], description: 'Export to CSV' },
    ]
  }
];

const KeyBadge = ({ keyName }) => (
  <span
    style={{
      display: 'inline-block',
      padding: '2px 8px',
      background: '#f1f5f9',
      border: '1px solid #e2e8f0',
      borderRadius: 4,
      fontFamily: 'monospace',
      fontSize: 11,
      fontWeight: 600,
      color: '#475569',
      marginRight: 4
    }}
  >
    {keyName}
  </span>
);

const KeyboardShortcutsModal = ({ visible, onClose }) => {
  return (
    <Modal
      title="Keyboard Shortcuts"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={700}
    >
      <Row gutter={[24, 24]}>
        {shortcutsList.map((section, idx) => (
          <Col span={12} key={idx}>
            <Space direction="vertical" size={12} style={{ width: '100%' }}>
              <Text strong style={{ fontSize: 12, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                {section.category}
              </Text>
              {section.shortcuts.map((shortcut, sIdx) => (
                <div key={sIdx} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div>
                    {shortcut.keys.map((key, kIdx) => (
                      <KeyBadge key={kIdx} keyName={key} />
                    ))}
                  </div>
                  <Text style={{ fontSize: 13, color: '#475569' }}>{shortcut.description}</Text>
                </div>
              ))}
            </Space>
          </Col>
        ))}
      </Row>
    </Modal>
  );
};

export default KeyboardShortcutsModal;
